import { Module } from "vuex";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { DevicesState } from "./types";
import { RootState } from "../types";

const namespaced = true;

export const state: DevicesState = {
  domains: [],
  customerId: "",
  tokens: [],
  devices: [],
  models: null,
};

export const devices: Module<DevicesState, RootState> = {
  namespaced,
  state,
  actions,
  mutations,
};
